import React from 'react';
import { BrowserRouter, Route, Routes, Switch, Link } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { useLocation } from 'react-router';
import { Header, Footer } from './components/Layout/Menu';
import { Route as PageRoute } from './components/Animation';

import { Home, Recruit, Service, News, Works, Company, Post, Voice, About, Contact } from './pages';

function App() {
  const location = useLocation();

  return (
    <div>
      <div className="f-base__line" data-state="left"></div>
      <div className="f-base__line" data-state="center"></div>
      <div className="f-base__line" data-state="right"></div>
      <Header />

      <AnimatePresence mode="wait">
        <Routes location={location} key={location.pathname}>
          <Route path={`/`} element={<PageRoute><Home /></PageRoute>} />
          <Route path={`/recruit`} element={<PageRoute><Recruit /></PageRoute>} />
          <Route path={`/service`} element={<PageRoute><Service /></PageRoute>} />
          <Route path={`/about`} element={<PageRoute><Company /></PageRoute>} />
          <Route path={`/contact`} element={<PageRoute><Contact /></PageRoute>} />

          {/* POST */}
          <Route path={`/posts`} element={<PageRoute><News /></PageRoute>} />
          <Route path={`/posts/page/:id`} element={<PageRoute><News /></PageRoute>} />
          <Route path={`/post/:postId`} element={<PageRoute><Post type="post" postType="posts" /></PageRoute>} />

          {/* WORKS */}
          <Route path={`/works`} element={<PageRoute><Works /></PageRoute>} />
          <Route path={`/works/page/:id`} element={<PageRoute><Works /></PageRoute>} />
          <Route path={`/post/works/:postId`} element={<PageRoute><Post type="post" postType="works" /></PageRoute>} />

          {/* VOICE */}
          <Route path={`/voice`} element={<PageRoute><Voice /></PageRoute>} />
          <Route path={`/voice/page/:id`} element={<PageRoute><Voice /></PageRoute>} />
          <Route path={`/post/voice/:postId`} element={<PageRoute><Post type="post" postType="voice" /></PageRoute>} />

        </Routes>
      </AnimatePresence>
      <Footer />
    </div>
  )
}

export default App;
